import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { setItemsFilter } from "../../redux/actions/menuActions";
import ViewSelector from "../../pages/order/components/ViewSelector";

import './SearchNew.scss';

const SearchNew = ({
  t,
  setItemsFilter,
  itemsFilter,
}) => {
  const [filterValue, setfilterValue] = useState(itemsFilter);
  const handleChange = (e) => {
    const { value } = e.currentTarget;
    setfilterValue(value);
    setItemsFilter(value);
  };

  return (
    <div className={"search-block"}>
      {/* <ViewSelector /> */}
      <input
        className="search-input"
        type="text"
        placeholder={t("search")}
        onChange={handleChange}
        value={filterValue}
      />
      {filterValue && (
        <div
          className={"clear-search"}
          onClick={() => {
            setfilterValue("");
            setItemsFilter("");
          }}
        >
          <FontAwesomeIcon icon="times" />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
     itemsFilter 
  } = state;

  return {
    itemsFilter,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setItemsFilter,
    },
    dispatch
  );

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SearchNew));
